<template>
  <div>
    <div class="pie-text text-center">
      <h2 class="font-weight-bolder">
        <!-- $23,994 -->
        {{ total.quantidade }}
      </h2>
      <span class="font-weight-bold">Operações</span>
    </div>

    <!-- echart -->
    <app-echart-doughnut :series="series" />

  </div>
</template>

<script>
// import { BCard } from 'bootstrap-vue'
import AppEchartDoughnut from '@core/components/charts/echart/AppEchartDoughnut.vue'

export default {
  components: {
    // BCard,
    AppEchartDoughnut,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    total: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data: [],
        },
      ],
    }
  },
  async created() {
    this.series[0].data = this.data
    // const { series: dataSeries, categories: dataCategories } = this
    // this.barChart.series[0].data = dataSeries
    // this.barChart.chartOptions.xaxis.categories = dataCategories
  },
}
</script>

<style lang="scss">
.card-body{
  position: relative;
  .pie-text{
    width: 105px;
    position:absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 44%;
    bottom: 0;
  }
  }
</style>
